import React, {useState} from "react";

const staticPath = '/images'

export const Image = ({
                          src,
                          style = null,
                          className = '',
                          onClick = null,
                          alt = '',
                          noPrefix = false,
                          removeHandler = null
                      }) => {

    const [isLoaded, setIsLoaded] = useState(false)

    const onLoad = () => {
        setIsLoaded(true)
    }

    return (
        <div style={{position: 'relative'}}>
            <img
                src={noPrefix ? src : (staticPath + src)}
                onLoad={onLoad}
                className={isLoaded ? className : (className + ' hidden')}
                style={style}
                onClick={onClick}
                alt={alt}
            />
            {removeHandler?(
                <button type="button" onClick={() => removeHandler(src)} className="close img_close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            ):''}
        </div>
    )
}